module.exports = __webpack_public_path__ + "static/instagram-8e57a9e1e0408a0ec3850ce1d0028132.png";